(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/views/pages/fractiongames-page.js') >= 0) return;  svs.modules.push('/modules/keno/views/pages/fractiongames-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.keno=_svs.keno||{};
_svs.keno.templates=_svs.keno.templates||{};
svs.keno.templates.fractiongames_page = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"ngFractiongamesRegion\" class=\"keno-fractiongames-container\"></div>\n";
},"useData":true});
Handlebars.partials['svs-keno-fractiongames_page'] = svs.keno.templates.fractiongames_page;
})(svs, Handlebars);


 })(window);